import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HelperService } from '../helper.service';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class VesselApiService {

  environmentUrl = "Debug api";
  constructor(
    private http: HttpClient,
    private helperService: HelperService
  ) {
    this.environmentUrl = environment.apiUrl;
  }

  public getOverviewStats(companyId: number): Observable<{
    totalVessels: number;
    completedBaselines: number;
    averageFleetAge: number;
  }> {
    return this.http.get<{
      totalVessels: number;
      completedBaselines: number;
      averageFleetAge: number;
    }>(
      `${this.environmentUrl}/api/vessels/company/${companyId}/overview-stats`,
      this.helperService.headers()
    );
  }

  getActiveVessels(companyId: number, limit = 100, currentPage = 1, active = 1, search: string | null = null): Observable<any> {
    let url = `${this.environmentUrl}/api/vessels/v2/all/${companyId}?limit=${limit}&currentPage=${currentPage}${active !== null ? `&active=${active}` : ''}`;
    if (search) {
      url += `&search=${encodeURIComponent(search)}`;
    }

    return this.http.get<any>(url, this.helperService.headers());
  }

  getArchivedVessels(companyId: number, limit = 100, currentPage = 1, active = 0, search: string | null = null): Observable<any> {
    let url = `${this.environmentUrl}/api/vessels/v2/all/${companyId}?limit=${limit}&currentPage=${currentPage}${active !== null ? `&active=${active}` : ''}`;
    if (search) {
      url += `&search=${encodeURIComponent(search)}`;
    }

    return this.http.get<any>(url, this.helperService.headers());
  }

  public archiveVessel(id: any): Observable<any> {
    return this.http.post<any>(
      `${this.environmentUrl}/api/vessels/archive/` + id,
      this.helperService.headers()
    );
  }

  public restoreVessel(id: any): Observable<any> {
    return this.http.post<any>(
      `${this.environmentUrl}/api/vessels/activate/` + id,
      this.helperService.headers()
    );
  }

  public importVesselData(imo: any): Observable<any> {
    return this.http.get<any>(
      `${this.environmentUrl}/api/vessels/v2/importVesselData/` + imo,
      this.helperService.headers()
    );
  }

  public getVesselTypes(): Observable<any> {
    return this.http.get<any>(`${this.environmentUrl}/api/vessels/v2/types`,
      this.helperService.headers());
  }

  public createVessel(createVesselDto: any): Observable<any> {
    return this.http.post<any>(
      `${this.environmentUrl}/api/vessels/v2/add`,
      createVesselDto,
      this.helperService.headers()
    );
  }

  public updateVessel(id: number, vesselDTO: any): Observable<any> {
    return this.http.put<any>(
      `${this.environmentUrl}/api/vessels/v2/update/${id}`,
      vesselDTO,
      this.helperService.headers()
    );
  }

  public getVesselById(vesselId: number): Observable<any> {
    return this.http.get<any>(
      `${this.environmentUrl}/api/vessels/v2/${vesselId}`,
      this.helperService.headers()
    );
  }

  public getFuelOptions(): Observable<any> {
    const title = "Fuel";
    return this.http.get<any>(
      `${this.environmentUrl}/api/vessel-calculation-inventory/options-lifecycle/${title}`,
      this.helperService.headers()
    );
  }

  public getLubricatingOilOptions(): Observable<any> {
    const title = "Lubricating%20Oil";
    return this.http.get<any>(
      `${this.environmentUrl}/api/vessel-calculation-inventory/options-lifecycle/${title}`,
      this.helperService.headers()
    );
  }

  public getRecyclingOptions(): Observable<any> {
    const title = "Recycling Method and Country";
    return this.http.get<any>(
      `${this.environmentUrl}/api/vessel-calculation-inventory/options-lifecycle/${title}`,
      this.helperService.headers()
    );
  }

  public getSteelSourceOptions(): Observable<any> {
    const title = "Steel Source";
    return this.http.get<any>(
      `${this.environmentUrl}/api/vessel-calculation-inventory/options-lifecycle/${title}`,
      this.helperService.headers()
    );
  }

  public getEnergyOptions(): Observable<any> {
    const title = "Energy In Assembly";
    return this.http.get<any>(
      `${this.environmentUrl}/api/vessel-calculation-inventory/options-lifecycle/${encodeURIComponent(title)}`,
      this.helperService.headers()
    );
  }

  public getActiveTotalEmissions(companyId: any): Observable<any> {
    return this.http.get<any>(
      `${this.environmentUrl}/api/vessels/v2/active-totalEmission/` + companyId,
      this.helperService.headers()
    );
  }

  public getArchivedTotalEmissions(companyId: any): Observable<any> {
    return this.http.get<any>(
      `${this.environmentUrl}/api/vessels/v2/archived-totalEmission/` + companyId,
      this.helperService.headers()
    );
  }

  public generatePdfForLifecycleScreening(id: any): Observable<any> {
    const url = `${this.environmentUrl}/api/vesselExport/generatePdf/lifecycle-screening/${id}`;
    return this.http.get(url, {
      ...this.helperService.headers(),
      responseType: 'blob' as 'json'
    });
  }

  getCanAddVessel(companyId: number): Observable<{ canAddVessel: boolean }> {
    const url = `${this.environmentUrl}/api/vessels/${companyId}/canAddVessel`;
    return this.http.get<{ canAddVessel: boolean }>(url);
  }

  public getAllSubtypes(): any {
    return this.http.get<string[]>(
      `${this.environmentUrl}/api/vessels/v2/subtypes`,
      this.helperService.headers()
    );
  }

  public getSubtypesByType(vesselType: string): any {
    return this.http.get<string[]>(
      `${this.environmentUrl}/api/vessels/v2/subtypes/${vesselType}`,
      this.helperService.headers()
    );
  }
}
